import { createReducer } from "@reduxjs/toolkit";
import {
  COMPONENT_CATEGORY_ERROR,
  COMPONENT_CATEGORY_LIST,
  COMPONENT_CATEGORY_LOADING,
  CREATE_COMPONENT_CATEGORY,
  EDIT_COMPONENT_CATEGORY,
  DELETE_COMPONENT_CATEGORY,
} from "../actions/types";

const initialState = {
  error: "",
  loading: false,
  data: [],
};

const componentCategoriesReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(COMPONENT_CATEGORY_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(COMPONENT_CATEGORY_ERROR, (state, { payload }) => {
      state.error = payload;
      state.loading = false;
    })
    .addCase(COMPONENT_CATEGORY_LIST, (state, { payload }) => {
      state.data = payload;
      state.loading = false;
    })
    .addCase(CREATE_COMPONENT_CATEGORY, (state, { payload }) => {
      Array.isArray(state.data)
        ? state.data.push(payload)
        : (state.data = [payload]);
      state.loading = false;
    })
    .addCase(EDIT_COMPONENT_CATEGORY, (state, { payload }) => {
      const index = state.data.findIndex((e) => e?.id === payload?.id);
      state.data[index] = payload;
      state.loading = false;
    })
    .addCase(DELETE_COMPONENT_CATEGORY, (state, { payload }) => {
      state.data = state.data.filter((e) => e?.id !== payload?.id);
      state.loading = false;
    });
});

export default componentCategoriesReducer;
